import { CFBaseSearchbarTokens } from '.';
export const getAnimatedStyles = ({ fieldSize, focused, hasText, }) => {
    const clearButtonSize = CFBaseSearchbarTokens.BUTTON_PHYSICAL_SIZES[fieldSize.toUpperCase()];
    const gap = CFBaseSearchbarTokens.ROOT_GAP;
    const paddings = CFBaseSearchbarTokens.ROOT_PADDINGS[fieldSize.toUpperCase()];
    const searchIconSize = CFBaseSearchbarTokens.ICON_SIZE;
    let backgroundColor, borderColor, paddingLeft, paddingRight;
    switch (true) {
        case focused:
            backgroundColor = CFBaseSearchbarTokens.BACKGROUND.FOCUSED;
            borderColor = CFBaseSearchbarTokens.BORDER_COLOR.FOCUSED;
            paddingLeft = paddings.FOCUSED.LEFT;
            paddingRight = paddings.FOCUSED.RIGHT + clearButtonSize + gap;
            break;
        case hasText:
            borderColor = CFBaseSearchbarTokens.BORDER_COLOR.DEFAULT;
            backgroundColor = CFBaseSearchbarTokens.BACKGROUND.DEFAULT;
            paddingLeft = paddings.FILLED.LEFT;
            paddingRight = paddings.FILLED.RIGHT + clearButtonSize + gap;
            break;
        default:
            backgroundColor = CFBaseSearchbarTokens.BACKGROUND.DEFAULT;
            borderColor = CFBaseSearchbarTokens.BORDER_COLOR.DEFAULT;
            paddingLeft = paddings.EMPTY.LEFT + searchIconSize + gap;
            paddingRight = paddings.EMPTY.RIGHT;
            break;
    }
    return {
        backgroundColor,
        borderColor,
        paddingLeft,
        paddingRight,
    };
};
export const getClearButtonSize = (fieldSize) => {
    switch (fieldSize) {
        case 'lg':
            return CFBaseSearchbarTokens.BUTTON_SIZES.LG;
        default:
            return CFBaseSearchbarTokens.BUTTON_SIZES.DEFAULT;
    }
};
export const getTypeSpec = (fieldSize) => {
    switch (fieldSize) {
        case 'lg':
            return CFBaseSearchbarTokens.TYPE_SPEC.LG;
        default:
            return CFBaseSearchbarTokens.TYPE_SPEC.DEFAULT;
    }
};
